import { Toast } from 'vant'
import { getOrderInfoByOrderNo } from '@/api/solutions/solution'
import { getCookie } from '@/utils/cookies'

export default {
  methods: {
    isMiniProgram () {
      const navigatorValue = window.$HMD$ && window.$HMD$.rNavigator
      const wxEnvironment = window.__wxjs_environment
      const miniProgramCookie = getCookie('MiniProgram')
      let miniProgramStorage = ''
      try {
        miniProgramStorage = window.localStorage.getItem('MiniProgram')
      } catch (error) {
        miniProgramStorage = '读取失败'
      }
      const isMiniProgram = navigatorValue === 'MiniProgram' || wxEnvironment === 'miniprogram' || miniProgramCookie === 'true' || miniProgramStorage === 'true'

      // 临时调试弹窗暂时关闭。
      // window.alert(
      //   '【小程序支付调试：环境判断】\n' +
      //   '判断结果：' + isMiniProgram + '\n' +
      //   'rNavigator：' + navigatorValue + '\n' +
      //   '__wxjs_environment：' + wxEnvironment + '\n' +
      //   'Cookie MiniProgram：' + miniProgramCookie + '\n' +
      //   'Storage MiniProgram：' + miniProgramStorage
      // )

      return isMiniProgram
    },
    redirectToMiniProgramPayment (orderId) {
      const miniUrl =
        '/subOrder/pages/wPayment' +
        '?orderIds=' + orderId +
        '&pageType=1'

      const windowMiniProgram = window.wx && window.wx.miniProgram
      const vueMiniProgram = this.$wx && this.$wx.miniProgram
      const miniProgram = windowMiniProgram || vueMiniProgram

      // 临时调试弹窗暂时关闭。
      // window.alert(
      //   '【小程序支付调试：准备跳转】\n' +
      //   'orderId：' + orderId + '\n' +
      //   'window.wx.miniProgram：' + !!windowMiniProgram + '\n' +
      //   'this.$wx.miniProgram：' + !!vueMiniProgram + '\n' +
      //   'redirectTo：' + !!(miniProgram && typeof miniProgram.redirectTo === 'function') + '\n' +
      //   'url：' + miniUrl
      // )

      if (!orderId || !miniProgram || typeof miniProgram.redirectTo !== 'function') {
        Toast('当前环境暂不支持小程序支付')
        return
      }

      miniProgram.redirectTo({
        url: miniUrl
      })
    },
    getOrderIdToMiniProgram (orderNo) {
      getOrderInfoByOrderNo(orderNo).then((res) => {
        // 临时调试弹窗暂时关闭。
        // window.alert(
        //   '【小程序支付调试：订单ID查询】\n' +
        //   'orderNo：' + orderNo + '\n' +
        //   'code：' + res.data.code + '\n' +
        //   'msg：' + res.data.msg
        // )
        if (res.data.code !== 1000 && res.data.msg === '处理成功') {
          this.redirectToMiniProgramPayment(res.data.code)
          return
        }
        Toast('订单处理中，请稍后重试')
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/miniProgramPayment.js